import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=b9685c00&scoped=true"
import script from "./multi-select.vue?vue&type=script&lang=js"
export * from "./multi-select.vue?vue&type=script&lang=js"
import style0 from "./multi-select.vue?vue&type=style&index=0&id=b9685c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9685c00",
  null
  
)

export default component.exports